import { AnyAction } from 'redux';
import { DriverLocation } from '../../types';

import { driversActions } from '../reducer';

export const setSelectedDriverLocation = (
  driverLocation: DriverLocation
): AnyAction => driversActions.setSelectedDriverLocation(driverLocation);
